// extracted by mini-css-extract-plugin
export default {"backgroundImageBot":"BackgroundImageMonthReportBotPosition_backgroundImageBot__OP+20"};